/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_Stopped_ImpersonatingInputs */

const en_mobile_admin_stopped_impersonating = /** @type {(inputs: Mobile_Admin_Stopped_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped impersonating`)
};

const es_mobile_admin_stopped_impersonating = /** @type {(inputs: Mobile_Admin_Stopped_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impersonación detenida`)
};

/**
* | output |
* | --- |
* | "Stopped impersonating" |
*
* @param {Mobile_Admin_Stopped_ImpersonatingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_stopped_impersonating = /** @type {((inputs?: Mobile_Admin_Stopped_ImpersonatingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Stopped_ImpersonatingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_stopped_impersonating(inputs)
	return en_mobile_admin_stopped_impersonating(inputs)
});